import { render, staticRenderFns } from "./PlansTable.vue?vue&type=template&id=5451f9a2&scoped=true&lang=pug"
import script from "./PlansTable.vue?vue&type=script&lang=js"
export * from "./PlansTable.vue?vue&type=script&lang=js"
import style0 from "./PlansTable.vue?vue&type=style&index=0&id=5451f9a2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5451f9a2",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {Icon: require('/home/docker/code/frontend/components/Icon.vue').default,PlansTableLi: require('/home/docker/code/frontend/components/PlansTableLi.vue').default,Tiers: require('/home/docker/code/frontend/components/Tiers.vue').default,Address: require('/home/docker/code/frontend/components/Address.vue').default,Pharmacy: require('/home/docker/code/frontend/components/Pharmacy.vue').default,DrugsMonthlyByPharmacy: require('/home/docker/code/frontend/components/DrugsMonthlyByPharmacy.vue').default,DrugsMonthlyByDrug: require('/home/docker/code/frontend/components/DrugsMonthlyByDrug.vue').default,DrugsYearlyByPharmacy: require('/home/docker/code/frontend/components/DrugsYearlyByPharmacy.vue').default,DrugsInfo: require('/home/docker/code/frontend/components/DrugsInfo.vue').default,PlanProvidersList: require('/home/docker/code/frontend/components/PlanProvidersList.vue').default,Stars: require('/home/docker/code/frontend/components/Stars.vue').default})
